<template>
  <v-row class="filters--list mb-4">
    <v-col cols="12" sm="12" md="4" lg="2">
      <!-- number: the backend takes the code as a number and refuses free text -->
      <FilterSearch
        searchTerm="appointmentCode"
        :fetchData="fetchDivergences"
        label="code"
        type="number"
        innerIcon="mdi-magnify"
      />
    </v-col>

    <v-col cols="12" sm="12" md="4" lg="2">
      <RealEstateSelectFilter :fetchData="fetchDivergences" />
    </v-col>

    <v-col cols="12" sm="12" md="4" lg="2">
      <FilterAutocomplete
        :label="$t('genericFilters.label.host')"
        :no-data-text="$t('host.label.typeToSearchHost')"
        :fetchData="fetchDivergences"
        :asyncSearch="fetchHostsBySearchText"
        :loading="isSearchingHosts"
        :items="hostSearchResults"
        prepend-inner-icon="mdi-magnify"
        type="hostId"
        value="id"
        item-text="name"
      />
    </v-col>

    <v-col cols="12" sm="12" md="4" lg="2">
      <FilterAutocomplete
        :label="$t('divergence.filters.status')"
        :fetchData="fetchDivergences"
        :items="divergenceStatusOptions"
        :initialValue="pendingOnly"
        type="statuses"
        multiple
      />
    </v-col>

    <v-col cols="12" sm="12" md="4" lg="2">
      <FilterAutocomplete
        :label="$t('divergence.filters.kind')"
        :fetchData="fetchDivergences"
        :items="divergenceKindOptions"
        type="kind"
      />
    </v-col>

    <v-col cols="12" sm="12" md="4" lg="2">
      <FilterAutocomplete
        :label="$t('divergence.filters.type')"
        :fetchData="fetchDivergences"
        :items="divergenceTypeOptions"
        type="type"
      />
    </v-col>

    <v-col cols="12" sm="12" md="4" lg="2">
      <FilterDate
        :fetchData="fetchDivergences"
        startDateProp="createdFrom"
        endDateProp="createdTo"
      />
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import FilterAutocomplete from '@/components/filters/FilterAutocomplete'
import FilterDate from '@/components/filters/FilterDate'
import FilterSearch from '@/components/filters/FilterSearch'
import RealEstateSelectFilter from '@/components/realEstate/RealEstateSelectFilter'

export default {
  name: 'DivergenceListFilters',

  components: {
    FilterAutocomplete,
    FilterDate,
    FilterSearch,
    RealEstateSelectFilter,
  },

  data() {
    return {
      // a fila abre no que precisa de ação; o chip fica visível e o operador pode limpar
      pendingOnly: ['AWAITING_APPROVAL'],
    }
  },

  computed: {
    ...mapGetters([
      'divergenceStatusOptions',
      'divergenceTypeOptions',
      'divergenceKindOptions',
      'hostSearchResults',
      'isSearchingHosts',
    ]),
  },

  methods: {
    ...mapActions(['fetchDivergences', 'fetchHostsBySearchText']),
  },
}
</script>
